import React, { useRef } from "react";
// import styles from "./Home.module.sass";
import PartenairesLogos from "../../components/Clients"; // "Ils nous font confiance" - logos des partenaires
import FonctionnalitesCles from "../../components/ValueProps"; // Fonctionnalités principales (IA, OPCO, etc.)
import AppelAction from "../../components/AppelAction";   
import FiabiliteSecurite from "./FiabiliteSecurite"; 
import HeroBanner from "./HeroBanner"; 
import Faq from "./Faq";
import PresentationSolution from "./PresentationSolution";
import PresentationServices from "./PresentationServices";
import PresentationFacturation from "./PresentationFacturation";
import SEOHead from "../../components/SEOHead";
import { usePageSEO } from "../../utils/seoUtils";

const Home = () => {
  const scrollToRef = useRef(null);
  const seoData = usePageSEO('/');

  return (
    <>
      <SEOHead {...seoData} />
      <HeroBanner scrollToRef={scrollToRef} />
      {/* <PartenairesLogos /> */}
      <FonctionnalitesCles className="section" />
      <PresentationSolution />
      <PresentationServices />
      <PresentationFacturation />   
      {/* <FiabiliteSecurite /> */}
      <Faq />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Home;
